"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Input_1 = require("@empiriecom/module-components/FormControls/Input");
var react_1 = __importDefault(require("react"));
var react_intl_1 = require("react-intl");
var index_1 = __importDefault(require("../../../hooks/useConfig/index"));
var index_2 = __importDefault(require("../IntlProvider/index"));
var NewsletterInputEmailTexts = react_intl_1.defineMessages({
    label: { id: 'nlInputEmail.label' },
    placeholder: { id: 'nlInputEmail.placeholder' },
    required: { id: 'input.email.required' },
});
var NewsletterInputEmail = function (_a) {
    var setIsFormValid = _a.setIsFormValid, isFormSubmitted = _a.isFormSubmitted, setIsFormSubmitted = _a.setIsFormSubmitted, errorMessage = _a.errorMessage;
    var config = index_1.default();
    var intl = react_intl_1.useIntl();
    var emailInput;
    var handleOnEmailChange = function (e) {
        setIsFormSubmitted(false);
        emailInput = e.target;
        var isEmailValid = config.regExp.eMail.checkProvider.test(emailInput.value);
        setIsFormValid(isEmailValid);
    };
    var inputElement = (react_1.default.createElement(Input_1.Input, { error: errorMessage ||
            (isFormSubmitted &&
                typeof emailInput === 'undefined' &&
                intl.formatMessage(NewsletterInputEmailTexts.required)) ||
            '', id: "newsletterEmail", name: "emailAdress", placeholder: intl.formatMessage(NewsletterInputEmailTexts.placeholder), type: "email", onChange: handleOnEmailChange, validationRules: [
            {
                required: true,
                error: {
                    id: 'input.email.required',
                },
            },
            {
                regEx: config.regExp.eMail.checkAt,
                error: {
                    id: 'input.email.error',
                },
            },
            {
                regEx: config.regExp.eMail.checkProvider,
                error: {
                    id: 'input.email.errorProvider',
                },
            },
        ] }));
    return (react_1.default.createElement(index_2.default, null,
        react_1.default.createElement("div", { id: "inputWrapper" }, inputElement)));
};
exports.default = NewsletterInputEmail;
//# sourceMappingURL=EmailInput.js.map